module.exports = __webpack_public_path__ + "img/Veranza-24-min.dc162d12.jpg";